import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8 14.67A6.667 6.667 0 1 1 8 1.335a6.667 6.667 0 0 1 0 13.333m-.664-4 4.714-4.715-.943-.943-3.771 3.772L5.45 6.898l-.943.943z"
    }, null, -1)
  ]))]))
}
export default { render: render }